import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Identity from './components/Identity';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import Brands from './components/Brands';
import Warranty from './components/Warranty';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/42bcf34a0b415e0867672df7cc9a89c1.jpeg" 
              alt="L&A Contract Flooring Corp." 
              className="h-12 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className={`text-sm font-medium tracking-wider uppercase transition-colors ${scrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>Services</a>
            <a href="#process" className={`text-sm font-medium tracking-wider uppercase transition-colors ${scrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>Process</a>
            <a href="#portfolio" className={`text-sm font-medium tracking-wider uppercase transition-colors ${scrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>Portfolio</a>
            <a href="#warranty" className={`text-sm font-medium tracking-wider uppercase transition-colors ${scrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>Warranty</a>
            <a href="#contact" className={`text-sm font-medium tracking-wider uppercase transition-colors ${scrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>Contact</a>
          </div>
          <div className="flex items-center space-x-4">
            <a href="tel:321-201-5387" className={`hidden md:block text-sm font-semibold ${scrolled ? 'text-[#FF6B35]' : 'text-[#FF6B35]'}`}>321-201-5387</a>
            <a href="#contact" className={`px-6 py-2 text-sm font-medium whitespace-nowrap rounded-full border-2 transition-all ${scrolled ? 'border-[#FF6B35] text-[#FF6B35] hover:bg-[#FF6B35] hover:text-white' : 'border-white text-white hover:bg-white hover:text-[#FF6B35]'}`}>Get Estimate</a>
          </div>
        </div>
      </nav>

      <Hero />
      <Identity />
      <Services />
      <Process />
      <Portfolio />
      <Brands />
      <Warranty />
      <Contact />
      <Footer />
    </div>
  );
}
